import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';

import { DefaultComponent } from './layout/default/default.component';
import { HeaderComponent } from './share/header/header.component';
import { FooterComponent } from './share/footer/footer.component';
import { HomepageComponent } from './components/home/homepage/homepage.component';
import { ResourceListComponent } from './components/home/resource-list/resource-list.component';
import { ReadingListComponent } from './components/pages/reading-list/reading-list.component';
import { ExploreComponent } from './components/pages/explore/explore.component';
import { NewinlibararyComponent } from './components/pages/newinlibarary/newinlibarary.component';
import { PopularListComponent } from './components/pages/popular-list/popular-list.component';
import { RecommendedListComponent } from './components/pages/recommended-list/recommended-list.component';
import { LibararyNewsComponent } from './components/pages/libarary-news/libarary-news.component';

import { BulletinsListComponent } from './components/pages/bulletins-list/bulletins-list.component';
import { BulletinDetailComponent } from './components/pages/bulletin-detail/bulletin-detail.component';
import { ReviewDetailComponent } from './components/pages/review-detail/review-detail.component';

import { DetailComponent } from './components/pages/detail/detail.component';
import { AwardsComponent } from './components/pages/awards/awards.component';
import { ForgotComponent } from './components/pages/forgot/forgot.component';
import { ReviewSearchComponent } from './components/pages/review-search/review-search.component';

import { ListComponent } from './components/searchlist/list/list.component';
import { ResetmailComponent } from './components/pages/resetmail/resetmail.component';
import { ErrorComponent } from './error/error.component';
import { DirectoryComponent } from './directory/directory.component';
import { InternalerrorComponent } from './internalerror/internalerror.component';
import { MyAccountComponent } from './components/settings/my-account/my-account.component';
import { HistoryComponent } from './components/settings/history/history.component';
import { PrintComponent } from './components/print/print.component';
import { UnsubscribeComponent } from './components/pages/unsubscribe/unsubscribe.component';
import { IdCardsComponent } from './components/pages/id-cards/id-cards.component';

const routes: Routes = [
  { path: '', component: DefaultComponent, children: [
    { path: '', component: HomepageComponent },
    { path: 'home', component: HomepageComponent },
    { path: 'reading-lists', component: ReadingListComponent },
    { path: 'explore/:pageId', component: ExploreComponent },
    { path: 'new', component: NewinlibararyComponent },
    { path: 'popular', component: PopularListComponent },
    { path: 'recommended', component: RecommendedListComponent },
    { path: 'news', component: LibararyNewsComponent },
    { path: 'awards', component: AwardsComponent },
    { path: 'searchlist', component: ListComponent },
    { path: 'search/:explore', component: ListComponent },
    { path: 'search/series', component: ListComponent },
    { path: 'search', component: ListComponent },
    { path: 'resource/list/:resource_id', component: ListComponent },
    { path: 'recentlist/:recentlist', component: ListComponent },
    { path: 'list/:my', component: ListComponent },
    { path: 'resources/:calltype/:chacheKey/:listId', component: DetailComponent },
    { path: 'account/resetpassword', component: ForgotComponent },
    { path: 'account/resetemail', component: ResetmailComponent },
    { path: 'bulletins', component: BulletinsListComponent },    
    { path: 'bulletin/:bulletin_id', component: BulletinDetailComponent },
    { path: 'searchreview', component: ReviewSearchComponent },
    { path: 'review/:id', component: ReviewDetailComponent },
    { path: 'my-account', component: MyAccountComponent },
    { path: 'history', component: HistoryComponent },
    { path: 'card', component: IdCardsComponent },
      


  ]},
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'printwithimages', component: PrintComponent },  
  { path: 'error/:type', component: ErrorComponent },
  { path: 'lib', component: DirectoryComponent },
  {path: '**', redirectTo: '/error/not-found'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule],
    declarations: []
  })
export class AppRoutingModule {}
